import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ServerOff = createReactComponent("ServerOff", ["svg", defaultAttributes, [["path", {
  d: "M7 2h13a2 2 0 012 2v4a2 2 0 01-2 2h-5",
  key: "106nhj"
}], ["path", {
  d: "M10 10L2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 002 2h6z",
  key: "d79b3j"
}], ["path", {
  d: "M22 17v-1a2 2 0 00-2-2h-1",
  key: "wpj4dh"
}], ["path", {
  d: "M4 14a2 2 0 00-2 2v4a2 2 0 002 2h16.5l1-.5.5.5-8-8H4z",
  key: "1sqkvj"
}], ["path", {
  d: "M6 18h.01",
  key: "1t0lit"
}], ["path", {
  d: "M2 2l20 20",
  key: "131xdx"
}]]]);
export default ServerOff;